import { MagicBellProvider } from '@magicbell/react-headless';
import type { ComponentProps, JSX } from 'react';

import { useMagicBellIdentity } from './useMagicBellIdentity';

// 50 per page, so client-side filtering (notification groups, project topics) has enough items.
const STORES: ComponentProps<typeof MagicBellProvider>['stores'] = [
    { id: 'default', defaultQueryParams: { per_page: 50 } },
    { id: 'unread', defaultQueryParams: { read: false, per_page: 50 } },
];

/** The one MagicBellProvider: each one mounted replaces the global stores; add stores with `setStore` instead. */
export function MagicBellConnection(): JSX.Element | null {
    const { identity } = useMagicBellIdentity();

    if (import.meta.env.MODE === 'test') {
        return null;
    }

    if (!identity) {
        // Loading, or unavailable: MagicBell needs the user's HMAC, see https://www.magicbell.com/docs/turn-on-hmac-authentication
        return null;
    }

    return (
        <MagicBellProvider
            apiKey={window.MAGIC_BELL_API_KEY}
            userExternalId={identity.externalId}
            userKey={identity.hmac}
            stores={STORES}
        >
            <></>
        </MagicBellProvider>
    );
}
